import authModule, { setApiGetter } from '@shared-library/store/modules/auth';
import api from '@/api';

// 设置 API getter
setApiGetter(() => api);

// 创建前端专用的auth模块
const frontendAuthModule = {
  ...authModule,
  
  // 覆盖getters，移除不需要的菜单getter
  getters: {
    ...authModule.getters,
    // 移除userMenus getter，因为前端不需要
  },
  
  // 覆盖actions，移除不需要的菜单action
  actions: {
    ...authModule.actions,
    
    // 移除fetchUserMenus action，因为前端不需要
    async fetchUserMenus() {
      console.warn('前端不需要获取用户菜单');
      return [];
    }
  },
  
  // 覆盖mutations，移除不需要的菜单mutation
  mutations: {
    ...authModule.mutations,
    
    // 移除setMenus mutation，因为前端不需要
    setMenus() {
      console.warn('前端不需要设置菜单');
    }
  }
};

// 移除菜单相关状态
frontendAuthModule.state = {
  ...authModule.state,
  menus: undefined // 前端不需要菜单状态
};

export default frontendAuthModule;